import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import styles from './NoticeDetail.module.scss';
import arrow from '../../assets/rightArrow.png';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import axiosClient from '../../libs/axiosClient';
import { INoticeType } from '../Notice/Notice';

function NoticeDetail() {
  const navigate = useNavigate();
  const { noticeId } = useParams();
  const location = useLocation();
  const stateNotice = location.state as INoticeType | undefined;

  const { data: notice } = useQuery<INoticeType | undefined>(
    ['notice', noticeId],
    () => {
      if (stateNotice) return stateNotice;
      return axiosClient
        .get('/data/notice?notice_type=2')
        .then((res) =>
          res.data.data.find(
            (n: INoticeType) => n.id === Number(noticeId),
          ),
        );
    },
    {
      staleTime: 60000 * 60 * 24,
      refetchOnWindowFocus: false,
    },
  );

  return (
    <>
      <Header />
      <main className={styles.container}>
        <header>
          <div className={styles.backBtn} onClick={() => navigate(-1)}>
            <img src={arrow} alt="뒤로가기" />
          </div>
          <h4>공지사항</h4>
        </header>
        {notice && (
          <>
            <h2 className={styles.noticeTitle}>
              <span>{notice.title}</span>
            </h2>
            <div className={styles.noticeInfo}>
              <span>DIETDR</span>
              <span>
                {notice.start_at.substring(0, 10).replace(/-/gi, '.')}
              </span>
            </div>
            <div
              className={styles.contentWrap}
              dangerouslySetInnerHTML={{
                __html: notice.body.replace(/\\/g, ''),
              }}
            ></div>
          </>
        )}
      </main>
      <Footer />
    </>
  );
}

export default NoticeDetail;
